import { render, staticRenderFns } from "./MovementUpdate.vue?vue&type=template&id=093def05&scoped=true&"
import script from "./MovementUpdate.vue?vue&type=script&lang=js&"
export * from "./MovementUpdate.vue?vue&type=script&lang=js&"
import style0 from "./MovementUpdate.vue?vue&type=style&index=0&id=093def05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093def05",
  null
  
)

export default component.exports